import { DataTargetType as t } from "@decentriq/graphql/dist/enums";
import { ExportDatasetInputSchema as a } from "@decentriq/graphql/dist/validation";
import { t as s } from "../../../../zod.BGwKDjoR.js";
import { z as r } from "../../../../zod.BRvRcVQy.js";
var n = /* @__PURE__ */ ((e) => (e.cookie_encrypted = "cookie_encrypted", e.cookie_idfa = "cookie_idfa", e.ppid = "ppid", e.cookie_rida = "cookie_rida", e.cookie_tvos = "cookie_tvos", e))(n || {});
const o = a(), i = o.extend({
  dv360: o.shape.dv360.nullable().and(r.object({
    userConsentGiven: r.boolean().refine((e) => e === !0, {
      message: "Consent is required before data can be exported"
    })
  })).optional()
}), u = {}, g = (e, c) => {
  switch (c) {
    case t.GoogleAdManager:
      return {
        googleAdManager: {
          bucket: "",
          credentials: "",
          identifierKind: "cookie_encrypted",
          inputHasHeader: !1,
          listId: "",
          objectName: ""
        },
        manifestHash: e
      };
    case t.Permutive:
      return {
        manifestHash: e,
        permutive: {
          credentials: {
            apiKey: ""
          },
          gcs: {
            bucketName: "",
            credentials: "",
            objectName: ""
          },
          importId: "",
          inputHasHeader: !1,
          segmentCode: "",
          segmentName: ""
        }
      };
    case t.S3:
      return {
        manifestHash: e,
        s3: {
          credentials: {
            accessKey: "",
            secretKey: ""
          },
          targetConfig: {
            bucket: "",
            objectKey: "",
            region: ""
          }
        }
      };
    case t.Adform:
      return {
        adformDsp: {
          aws: {
            credentials: {
              accessKey: "",
              secretKey: ""
            },
            targetConfig: {
              bucket: "",
              objectKey: "",
              region: ""
            }
          },
          segmentOwners: []
        },
        manifestHash: e
      };
    case t.Azure:
      return {
        azure: {
          credentials: {
            blobName: "",
            sasToken: "",
            storageAccount: "",
            storageContainer: ""
          }
        },
        manifestHash: e
      };
    case t.GoogleCloudStorage:
      return {
        gcs: {
          bucketName: "",
          credentials: "",
          objectName: ""
        },
        manifestHash: e
      };
    case t.GoogleDv_360:
      return {
        dv360: {
          advertiserId: "",
          credentials: "",
          description: "",
          displayName: "",
          membershipDurationDays: "",
          userConsentGiven: !1
        },
        manifestHash: e
      };
    case t.Meta:
      return {
        manifestHash: e,
        meta: {
          accessToken: "",
          adAccountId: "",
          audienceName: ""
        }
      };
    case t.Splicky:
      return {
        manifestHash: e,
        splicky: {
          seatId: "",
          userDefinedAudienceName: ""
        }
      };
    case t.MicrosoftDsp:
      return {
        manifestHash: e,
        microsoftDsp: {
          memberId: "",
          segmentCode: "",
          segmentShortName: ""
        }
      };
    default:
      return u;
  }
}, y = (e) => {
  switch (e) {
    default:
      return s(i);
  }
};
export {
  n as GoogleAdIdentifierKind,
  u as defaultValues,
  g as getDefaultValuesBySyncType,
  y as getResolverBySyncType,
  i as schema
};
//# sourceMappingURL=model.js.map
